import { useRef } from 'react';
import { UseDownloadQRCodePDFOptions } from './use-download-qr-code-pdf.types';
import { downloadBlob } from '../../utils/download-blop';
import { generateQRCodePDF } from '../../utils/generate-qr-code-pdf';

export const useDownloadQRCodePDF = ({
  fileName = 'qrcode.pdf',
  ...pdfOptions
}: UseDownloadQRCodePDFOptions) => {
  const canvasRef = useRef<HTMLDivElement>(null);

  const handleDownload = async () => {
    const canvas = canvasRef.current?.querySelector('canvas');
    if (!canvas) {
      return;
    }

    const dataUrl = canvas.toDataURL('image/png');
    const blob = await generateQRCodePDF(dataUrl, pdfOptions);
    downloadBlob(blob, fileName);
  };

  return { canvasRef, handleDownload };
};
